import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {DartAPIService} from "./dart.service";
import {handleErrors} from "../misc/handle-errors.decorator";

export type DartDealImportWarningModel = {
  template: boolean;
  withoutNetPriceSolutionIdsDartDealNumber: {
    dartDeal: string[];
    devicesWithoutValidNetPrice: string[];
    withoutNetPriceSolutionIdsDartDealNumber: string[];
  };
};

@Component({
  templateUrl: "./dartDealImport-warning.template.pug",
  providers: [DartAPIService],
})
export class DartDealImportWarningComponent extends DialogComponent<DartDealImportWarningModel, boolean> {
  template: boolean = false;
  dartDeal: string;
  netPrice: string;
  supplies: string;
  withoutNetPriceSolutionIdsDartDealNumber: {
    dartDeal: string[];
    devicesWithoutValidSKUBA: string[];
    devicesWithoutValidNetPrice: string[];
  };

  constructor(
    public dialogService: DialogService,
    public dartApiService: DartAPIService,
  ) {
    super(dialogService);
    this.result = false;
  }

  async ready() {
    this.dartDeal = this.withoutNetPriceSolutionIdsDartDealNumber.dartDeal.join(", ");
    this.supplies = this.withoutNetPriceSolutionIdsDartDealNumber.devicesWithoutValidSKUBA.join(", ");
    this.netPrice = this.withoutNetPriceSolutionIdsDartDealNumber.devicesWithoutValidNetPrice.join(", ");
  }

  @handleErrors()
  async continueImport(): Promise<void> {
    this.dialogService.changeContinueToImport({continueToImport: true, continueToImportTemplate: this.template});
    this.result = true;
    this.close();
  }
}
